import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-md bg-foreground-900 text-background-50 hover:bg-primary-500 transition-colors flex items-center justify-center cursor-pointer"
      aria-label="返回顶部"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </button>
  );
}